// Module
var code = "<svg viewBox=\"0 0 20 20\" fill=currentColor> <path d=\"M11 6a3 3 0 11-6 0 3 3 0 016 0zM14 17a6 6 0 00-12 0h12zM13 8a1 1 0 100 2h4a1 1 0 100-2h-4z\"/> </svg> ";
// Exports
module.exports = code;